import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import Skeleton from '../loaders/Skeleton';

const ConditionalPropertiesPanelSkeletonLoader = () => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Skeleton, {
      "data-test-id": "conditional-properties-panel-skeleton-loader"
    }), /*#__PURE__*/_jsx(Skeleton, {
      type: "description"
    }), /*#__PURE__*/_jsx(Skeleton, {}), /*#__PURE__*/_jsx(Skeleton, {
      type: "description"
    })]
  });
};

export default ConditionalPropertiesPanelSkeletonLoader;